import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatNativeDateModule } from '@angular/material/core';
import { MatDatepickerModule } from '@angular/material/datepicker';
import { MatDialogModule } from '@angular/material/dialog';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatListModule } from '@angular/material/list';
import { MatMenuModule } from '@angular/material/menu';
import { MAT_PAGINATOR_DEFAULT_OPTIONS, MatPaginatorIntl, MatPaginatorModule } from '@angular/material/paginator';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { MatProgressSpinnerModule } from '@angular/material/progress-spinner';
import { MatSelectModule } from '@angular/material/select';
import { MatSortModule } from '@angular/material/sort';
import { MatStepperModule } from '@angular/material/stepper';
import { MatTableModule } from '@angular/material/table';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatTreeModule } from '@angular/material/tree';
import { RouterModule } from '@angular/router';
import { TranslocoModule } from '@jsverse/transloco';
import { STANDARD_ROW_LIMIT, STANDARD_ROW_OPTONS } from '../app.models';
import { CustomPaginatorIntl } from './custom-paginator-intl';
import { IM2MCommonModule } from '@liebherr/old-sage-ui';
import { Im2mTooltipContentComponent, Im2mTooltipDirective } from '@m2mgate/sage-ui';

@NgModule({
    declarations: [],
    imports: [
        // m2mgate-old-sage-ui
        IM2MCommonModule,
        // m2mgate-sage-ui
        Im2mTooltipDirective,
        Im2mTooltipContentComponent,
        // angular
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslocoModule,
        // material
        MatIconModule,
        MatListModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatTableModule,
        MatSortModule,
        MatMenuModule,
        MatPaginatorModule,
        MatButtonModule,
        MatMenuModule,
        MatDialogModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatTreeModule,
        MatStepperModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
    ],
    exports: [
        // m2mgate-old-sage-ui
        IM2MCommonModule,
        // m2mgate-sage-ui
        Im2mTooltipDirective,
        Im2mTooltipContentComponent,
        // angular
        CommonModule,
        FormsModule,
        ReactiveFormsModule,
        RouterModule,
        TranslocoModule,
        // material
        MatIconModule,
        MatListModule,
        MatFormFieldModule,
        MatSelectModule,
        MatInputModule,
        MatTableModule,
        MatSortModule,
        MatMenuModule,
        MatPaginatorModule,
        MatButtonModule,
        MatMenuModule,
        MatDialogModule,
        MatTooltipModule,
        MatCheckboxModule,
        MatTreeModule,
        MatStepperModule,
        MatDatepickerModule,
        MatNativeDateModule,
        MatProgressBarModule,
        MatProgressSpinnerModule,
        MatAutocompleteModule,
    ],
    providers: [
        {
            provide: MAT_PAGINATOR_DEFAULT_OPTIONS,
            useValue: {
                // formFieldAppearance: 'outline',
                pageSize: STANDARD_ROW_LIMIT,
                pageSizeOptions: STANDARD_ROW_OPTONS,
                showFirstLastButtons: true,
            },
        },
        {
            provide: MatPaginatorIntl,
            useClass: CustomPaginatorIntl,
        },
    ],
})
export class ExternalModule {}
